import { render } from "./IconTrekSuspensionRear.vue?vue&type=template&id=19fa04aa"
import script from "./IconTrekSuspensionRear.vue?vue&type=script&lang=js"
export * from "./IconTrekSuspensionRear.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__